/**
 * Updates CSS custom properties for header and announcement-bar heights.
 * Also sets a combined --total-header-height.
 */
function updateHeaderHeights() {
  const header = document.querySelector('header');
  const announcementBar = document.querySelector('.announcement-bar');

  if (!header && !announcementBar) {
    console.warn('[HeaderHeight] Neither header nor announcement bar found. Nothing to update.');
    return;
  }

  const headerHeight = header.offsetHeight;
  const announcementBarHeight = announcementBar.offsetHeight;
  const totalHeight = headerHeight + announcementBarHeight;

  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
  document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
}

/**
 * Subscribes to the `transitionend` event for a given element and propertyName,
 * then calls the callback when it matches the specified property.
 * @param {HTMLElement} element - The element to observe.
 * @param {string} watchedProperty - The CSS property to check (e.g. "transform").
 * @param {Function} callback - The function to call when the transition ends.
 */
function watchTransformTransition(element, watchedProperty, callback) {
  if (!element) return;

  element.addEventListener('transitionend', (event) => {
    if (event.propertyName === watchedProperty) {
      callback();
    }
  });
}

/**
 * Initializes transition observers for the header and announcement bar,
 * and performs an initial height calculation.
 */
function initHeaderHeightWatchers() {
  const header = document.querySelector('header');
  const announcementBar = document.querySelector('.announcement-bar');

  // Watch for transform transition on header
  watchTransformTransition(header, 'transform', updateHeaderHeights);

  // Watch for transform transition on announcement bar
  watchTransformTransition(announcementBar, 'transform', updateHeaderHeights);

  updateHeaderHeights();
}

document.addEventListener('DOMContentLoaded', initHeaderHeightWatchers);